/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FondsvorauszahlungInfo } from './fondsvorauszahlungInfo';
import { MessageContent } from './messageContent';
import { ZahlungsfequenzInfo } from './zahlungsfequenzInfo';
import { PraemienanpassungInfo } from './praemienanpassungInfo';
import { BeguenstigungInfo } from './beguenstigungInfo';
import { AblaufPoliceInfo } from './ablaufPoliceInfo';
import { ContactFile } from './contactFile';


export interface ContactMessage { 
    policennummer?: string;
    partnernummer?: string;
    contactRequestId?: string;
    reason: ContactMessage.ReasonEnum;
    message: MessageContent;
    files: Array<ContactFile>;
    ablaufPoliceInfo?: AblaufPoliceInfo;
    beguenstigungInfo?: BeguenstigungInfo;
    fondsvorauszahlungInfo?: FondsvorauszahlungInfo;
    praemienanpassungInfo?: PraemienanpassungInfo;
    zahlungsfequenzInfo?: ZahlungsfequenzInfo;
}
export namespace ContactMessage {
    export type ReasonEnum = 'ablaufPv' | 'adressAenderungPv' | 'allgemein' | 'aenderungsAntrag' | 'automatischeAnpassungAendernPv' | 'beguenstigung' | 'berufAendernPv' | 'dynamikAendernPv' | 'erhoehungPv' | 'erwerbsunfaehigkeit' | 'feedbackPv' | 'gwgDatenaktualisierung' | 'fondsswitch' | 'fondsvorauszahlung' | 'name' | 'partnerAenderungPv' | 'praemienfreistellung' | 'praemienreduktion' | 'risikozwischenversicherung' | 'rueckerstattung3a' | 'versicherungsdauer' | 'vnWechselPv' | 'vollmachtPv' | 'vorsorgeart' | 'wiederinkraftsetzungPv' | 'wirtschaftBerechtigterAendernPv' | 'zahlungsfrequenz' | 'zahlungsmethode' | 'zivilstand' | 'kupoChatArchiv';
    export const ReasonEnum = {
        ABLAUF_PV: 'ablaufPv' as ReasonEnum,
        ADRESS_AENDERUNG_PV: 'adressAenderungPv' as ReasonEnum,
        ALLGEMEIN: 'allgemein' as ReasonEnum,
        AENDERUNGS_ANTRAG: 'aenderungsAntrag' as ReasonEnum,
        AUTOMATISCHE_ANPASSUNG_AENDERN_PV: 'automatischeAnpassungAendernPv' as ReasonEnum,
        BEGUENSTIGUNG: 'beguenstigung' as ReasonEnum,
        BERUF_AENDERN_PV: 'berufAendernPv' as ReasonEnum,
        DYNAMIK_AENDERN_PV: 'dynamikAendernPv' as ReasonEnum,
        ERHOEHUNG_PV: 'erhoehungPv' as ReasonEnum,
        ERWERBSUNFAEHIGKEIT: 'erwerbsunfaehigkeit' as ReasonEnum,
        FEEDBACK_PV: 'feedbackPv' as ReasonEnum,
        GWG_DATENAKTUALISIERUNG: 'gwgDatenaktualisierung' as ReasonEnum,
        FONDSSWITCH: 'fondsswitch' as ReasonEnum,
        FONDSVORAUSZAHLUNG: 'fondsvorauszahlung' as ReasonEnum,
        NAME: 'name' as ReasonEnum,
        PARTNER_AENDERUNG_PV: 'partnerAenderungPv' as ReasonEnum,
        PRAEMIENFREISTELLUNG: 'praemienfreistellung' as ReasonEnum,
        PRAEMIENREDUKTION: 'praemienreduktion' as ReasonEnum,
        RISIKOZWISCHENVERSICHERUNG: 'risikozwischenversicherung' as ReasonEnum,
        RUECKERSTATTUNG3A: 'rueckerstattung3a' as ReasonEnum,
        VERSICHERUNGSDAUER: 'versicherungsdauer' as ReasonEnum,
        VN_WECHSEL_PV: 'vnWechselPv' as ReasonEnum,
        VOLLMACHT_PV: 'vollmachtPv' as ReasonEnum,
        VORSORGEART: 'vorsorgeart' as ReasonEnum,
        WIEDERINKRAFTSETZUNG_PV: 'wiederinkraftsetzungPv' as ReasonEnum,
        WIRTSCHAFT_BERECHTIGTER_AENDERN_PV: 'wirtschaftBerechtigterAendernPv' as ReasonEnum,
        ZAHLUNGSFREQUENZ: 'zahlungsfrequenz' as ReasonEnum,
        ZAHLUNGSMETHODE: 'zahlungsmethode' as ReasonEnum,
        ZIVILSTAND: 'zivilstand' as ReasonEnum,
        KUPO_CHAT_ARCHIV: 'kupoChatArchiv' as ReasonEnum
    };
}


